/* eslint react/prop-types: 0 */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import FullDetailsAccordion from '../../../components/FullDetailsAccordion';
import TabDetails from '../TabDetails';
import { useFetchFieldData } from '../../../hooks/use-fetch-field-data';
import { ENTITY_OBJECT_TYPES } from '../../../shared/constants/entity.constants';

import './styles.scss';

/**
 * @param {{
 * serviceList: any;
 * layout: any;
 * showLoader: VoidFunction;
 * }} props
 */
const ServiceTab = ({ serviceList, layout, showLoader }) => {
  const { id: tabId } = useParams();
  const [selectedId, setSelectedId] = useState('');
  const {
    entityCards: fieldsData,
    selectEntity,
    setEntityLayout,
    updateEntityValues
  } = useFetchFieldData(tabId);

  useEffect(() => {
    setEntityLayout(layout);
  }, [layout, setEntityLayout]);

  const selectCallback = (id) => {
    selectEntity(id);
    setSelectedId(id);
  };

  if (!Array.isArray(serviceList)) {
    return;
  }

  return serviceList.filter(Boolean).map((item) => (
    <FullDetailsAccordion
      key={item.id}
      detailsComponent={
        <TabDetails
          fieldsData={fieldsData}
          tabId={tabId}
          selectedId={item.id}
          showLoader={showLoader}
          objectType={ENTITY_OBJECT_TYPES.SERVICE}
          onValuesSaved={updateEntityValues}
        />
      }
      selectCallback={selectCallback}
      expanded={selectedId === item.id}
      {...item}
    >
      <>
        <span className="title">{item.name}</span>
        <br />
        <span className="subtitle">{item.email}</span>
      </>
    </FullDetailsAccordion>
  ));
};

export default ServiceTab;
